"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createTestIdFunc = void 0;
function createTestIdFunc(base) {
    return (part) => [base, part].filter(Boolean).join('-');
}
exports.createTestIdFunc = createTestIdFunc;
//# sourceMappingURL=attribute.js.map